<!-- <template>
  <div class="project-card">
    <div class="project-left-card">
      <div class="icon">
        <i class="fa-solid fa-gear"></i>
      </div>
      <h4>Application de suivi d'interventions</h4>
      <div class="project-corps">
        <p>
          Application intuitive qui permet à l'utilisateur de tracker ses
          interventions de maintenance sur différentes machines machines. Avec
          un tableau pour pouvoir consulter les interventions effectuées, un
          boutons d'ajout d'intervention, un système de filtre, et un bouton
          d'export vers un format csv.
        </p>
      </div>
      <ul class="tech-stack">
        <li>
          <i class="fa-brands fa-vuejs"></i>
          <p>Vue.js</p>
        </li>
        <li>
          <i class="fa-brands fa-node-js"></i>
          <p>Node.js</p>
        </li>
        <li>
          <i class="fa-solid fa-leaf"></i>
          <p>MongoDB</p>
        </li>
        <li>
          <i class="fa-brands fa-square-figma"></i>
          <p>Figma</p>
        </li>
      </ul>
    </div>
    <img src="@/assets/images/reporting-app.png" alt="reporting present" />
  </div>
</template> -->

<template>
  <div class="project-card">
    <div class="project-left-card">
      <div class="icon">
        <i :class="icon"></i>
      </div>

      <h4>{{ title }}</h4>

      <div class="project-corps">
        <p>{{ description }}</p>
      </div>

      <ul class="tech-stack">
        <li v-for="(tech, i) in techStack" :key="i">
          <i :class="tech.icon"></i>
          <p>{{ tech.label }}</p>
        </li>
      </ul>
    </div>

    <img :src="image" :alt="title" />
  </div>
</template>

<script>
export default {
  name: "ProjectCard",
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: "fa-solid fa-gear",
    },
    image: {
      type: String,
      required: true,
    },
    techStack: {
      type: Array,
      default: () => [],
      // Exemple:
      // [ { icon: "fa-brands fa-vuejs", label: "Vue.js" }, ... ]
    },
  },
};
</script>

<style scoped lang="scss">
.project-card {
  background: #162032;
  border-radius: 16px;
  padding: 35px 25px;
  text-align: left;
  color: #ffffff;
  transition: 0.3s;
  border: 1px solid rgba(255, 255, 255, 0.05);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);

  display: flex;
  gap: 25px;

  &:hover {
    transform: translateY(-5px);
    background: #1b263a;
  }

  img {
    width: auto;
    height: 275px;
    border-radius: 8px;
    margin-top: 12px;
    object-fit: cover;
  }
}

.tech-stack {
  display: flex;
  gap: 15px;
  margin-top: 15px;
  flex-wrap: wrap;

  li {
    display: flex;
    align-items: center;
    gap: 5px;
    background: #0f172a;
    padding: 8px 12px;
    border-radius: 8px;
    font-size: 0.9rem;

    i {
      font-size: 1.2rem;
      color: #3b82f6;
    }
  }
}
/* ----  MOBILE / TABLET  ---- */
@media (max-width: 768px) {
  .project-card {
    flex-direction: column;
    padding: 25px 18px;
    gap: 20px;

    img {
      width: 100%;
      height: auto;
      margin: 0;
    }
  }
  .tech-stack li {
    padding: 6px 10px;
    font-size: 12px;

    i {
      font-size: 16px;
    }
  }
}

/* ----  VERY SMALL SCREENS  ---- */
@media (max-width: 480px) {
  .project-card {
    padding: 20px 15px;
  }

  .project-left-card {
    h4 {
      font-size: 1.1rem;
    }

    p {
      font-size: 14px;
    }
  }

  .tech-stack li {
    padding: 6px 10px;
    font-size: 12px;

    i {
      font-size: 12px;
    }

    p {
      font-size: 12px;
    }
  }
}

.project-left-card {
  display: flex;
  flex-direction: column;

  p {
    text-align: justify;
  }

  .icon {
    width: 52px;
    height: 52px;
    border-radius: 12px;
    background: #1e3a8a;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;

    i {
      font-size: 22px;
      color: #a5c4ff;
    }
  }
}
</style>
